import { ContactShadows, Environment, Float, Html, PresentationControls, Text, useGLTF } from "@react-three/drei"
import { useFrame, useThree } from "@react-three/fiber"
import { useRef, useState } from "react"
import * as THREE from "three"

const defaultPos = new THREE.Vector3(-3, 1.5, 4)
const zoomedPos = new THREE.Vector3(0.25, 1, 1.5)
const defaultLookAtTarget = new THREE.Vector3(0, 0, 0)
const zoomedLookAtTarget = new THREE.Vector3(0, 0.5, -1.5)

export default function Experience() {
  const [hovered, setHovered] = useState(false)
  const { camera } = useThree()

  const currentLookAt = useRef(defaultLookAtTarget.clone())

  const computer = useGLTF(
    "https://vazxmixjsiawhamofees.supabase.co/storage/v1/object/public/models/macbook/model.gltf"
  )

  useFrame(() => {
    const targetPos = hovered ? zoomedPos : defaultPos
    const lookAtTarget = hovered ? zoomedLookAtTarget : defaultLookAtTarget

    // Smooth camera position
    camera.position.lerp(targetPos, 0.05)

    // Smooth lookAt target
    currentLookAt.current.lerp(lookAtTarget, 0.05)
    camera.lookAt(currentLookAt.current)
  })

  return (
    <>
      <color attach="background" args={["#d8e4cd"]} />
      <Environment preset="city" />

      <PresentationControls
        global
        rotation={[0.13, 0.1, 0]}
        polar={[-0.4, 0.2]}
        azimuth={[-1, 0.75]}
        damping={0.25}
        snap
      >
        <Float rotationIntensity={0.2} floatIntensity={0.5}>
          <rectAreaLight
            width={2.5}
            height={1.65}
            intensity={65}
            color={"#d8e4cd"}
            rotation={[0.1, Math.PI, 0]}
            position={[0, 0.55, -1.15]}
          />

          <primitive object={computer.scene} position-y={-1.2}>
            <Html
              transform
              wrapperClass="html-screen"
              distanceFactor={1.17}
              position={[0, 1.56, -1.4]}
              rotation-x={-0.256}
              scale={0.8}
            >
              <iframe
                title="Eliška Haladová"
                src="https://eliskahaladova.duclonghoang.com"
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
              />
            </Html>
          </primitive>

          <Text
            font={"bangers-v20-latin-regular.woff"}
            fontSize={0.8}
            position={[2, 0.75, 0.75]}
            rotation-y={-1.25}
            maxWidth={4}
            textAlign={"center"}
            color={"#000000"}
          >
            Eliska Haladova
          </Text>
        </Float>
      </PresentationControls>
      <ContactShadows position-y={-1.4} opacity={0.4} scale={5} blur={2.4} />
    </>
  )
}
